import type { MisconceptionDefinition } from '../types'

/** REK — Schatten basis-misconcepties (slice 3). */
export const schattenBasisMisconceptions: MisconceptionDefinition[] = [
  // ── REK-SCHATTEN specific misconceptions ─────────────────────────────
  {
    id: 'rek.schatten-exact-als-fout',
    label: 'Schat: denkt dat exact antwoord fout is',
    module: 'Basisrekenen',
    description:
      'Bij "welk antwoord kan niet kloppen"-vragen kiest leerling het exacte antwoord omdat het niet identiek is aan de schatting.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-klein-verschil-is-fout',
    label: 'Schat: klein verschil zien als fout',
    module: 'Basisrekenen',
    description:
      'Leerling denkt dat een antwoord fout is als het iets afwijkt van de schatting, in plaats van te kijken naar de ordegrootte.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-schatting-is-fout',
    label: 'Schat: denkt dat schatting niet kan kloppen',
    module: 'Basisrekenen',
    description:
      'Leerling kiest de schatting zelf als "kan niet kloppen", omdat het niet het exacte antwoord is.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-afronden-te-ver',
    label: 'Schat: rondt te ver af',
    module: 'Basisrekenen',
    description:
      'Leerling rondt af naar een tiental/honderdtal dat verder weg ligt dan het dichtstbijzijnde, waardoor de schatting onnauwkeurig wordt.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-maar-een-getal',
    label: 'Schat: rondt maar één getal af',
    module: 'Basisrekenen',
    description:
      'Leerling rondt slechts één van twee operanden af bij schatten, waardoor de schatting bijna een exacte berekening wordt.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-afronden-verkeerde-richting',
    label: 'Schat: rondt verkeerde kant op',
    module: 'Basisrekenen',
    description:
      'Leerling rondt naar beneden af terwijl naar boven afronden dichter bij ligt (of omgekeerd) — kiest niet het dichtstbijzijnde getal.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-vergeet-vermenigvuldigen',
    label: 'Schat: vergeet aantal mee te rekenen',
    module: 'Basisrekenen',
    description:
      'Bij context-schattingen geeft leerling alleen de prijs/eenheid en vergeet te vermenigvuldigen met het aantal stuks.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-deeltal-als-antwoord',
    label: 'Schat: geeft deeltal in plaats van quotiënt',
    module: 'Basisrekenen',
    description:
      'Bij een schat-deling geeft leerling het deeltal (bv. 200) als antwoord in plaats van het quotiënt (bv. 50).',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-keer-ipv-delen',
    label: 'Schat: vermenigvuldigt i.p.v. te delen',
    module: 'Basisrekenen',
    description:
      'Bij een verdelingsvraag in een schat-context vermenigvuldigt leerling i.p.v. te delen.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-te-nauwkeurig',
    label: 'Schat: te nauwkeurig afgerond',
    module: 'Basisrekenen',
    description:
      'Leerling rondt af naar getallen die nog steeds moeilijk uit het hoofd te berekenen zijn (bv. 620−190) i.p.v. naar handige ronde getallen (600−200).',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.estimation-error',
    label: 'Tussenschatting bij compenseren wijkt te ver af',
    module: 'Basisrekenen',
    description:
      'Bij een handige-rekenen-strategie (compenseren, splitsen) kiest leerling een tussenschatting die te grof is om mee terug te corrigeren, waardoor de eindwaarde te ver van de exacte uitkomst ligt. Onderscheid met de rek.schatten-* familie: dáár gaat het om de schat-context zelf; hier om compensatie-strategie.',
    typicalFamilies: ['REK-HANDIG-DEEL', 'REK-HANDIG-PLUS-MIN'],
  },
]
